import { LoaderCircle } from "lucide-react";

/**
 * CustomLoadingError — Universal error screen component
 * For displaying loading/request failure states in pages and components
 */
export function CustomLoader({ size }: { size?: string }) {
  let heightClass = "min-h-[60vh]";
  let iconSize = "w-24 h-24";

  switch (size) {
    case "small":
      heightClass = "min-h-[20vh]";
      iconSize = "w-16 h-16";
      break;
    case "medium":
      heightClass = "min-h-[40vh]";
      iconSize = "w-20 h-20";
      break;
    default:
      heightClass = "min-h-[60vh]";
      iconSize = "w-24 h-24";
      break;
  }

  return (
    <div
      className={
        "flex flex-col justify-center items-center px-10 text-center " +
        heightClass
      }
    >
      <p className="text-accent-bg-cold/30 mb-5">
        <LoaderCircle className={iconSize + " animate-spin"} />
      </p>
      <div className="text-accent-bg-cold/30 text-sm mb-2">Loading...</div>
    </div>
  );
}

export default CustomLoader;
